import {
  ADD_VEHICLE_TYPE,
  VEHICLE_TYPE_ERROR,
  GET_VEHICLE_TYPE,
  GET_VEHICLE_TYPES,
} from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";

export const getAllVehicleTypes = async () => {
  try {
    const res = await customAxios.get("/api/admin/vehicletypes");
    return res.data;
  } catch (err) {
    return [];
  }
};

// get vehicle by id
export const getVehicleType = (id) => async (dispatch) => {
  try {
    const res = await customAxios.get(`/api/admin/vehicletypes/${id}`);
    dispatch({
      type: GET_VEHICLE_TYPE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: VEHICLE_TYPE_ERROR,
      payload: { msg: err.response.statusText, status: err.response },
    });
  }
};

// get vehicle types
export const getVehicleTypes = () => async (dispatch) => {
  try {
    const res = await customAxios.get("/api/admin/vehicletypes");
    dispatch({
      type: GET_VEHICLE_TYPES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: VEHICLE_TYPE_ERROR,
      payload: { msg: err.response, status: err.response },
    });
  }
};

// Creates a vehicle type, or overwrites an existing one when `edit` is set.
//
// Resolves to { ok, message }. Both screens confirm behind a dialog and report the
// outcome themselves, so the failure message goes back to the caller rather than to
// an alert raised behind the open dialog.
export const addVehicleType =
  (formdata, history, edit = false) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await customAxios.post(
        "/api/admin/vehicletypes",
        formdata,
        config
      );
      dispatch({
        type: ADD_VEHICLE_TYPE,
        payload: res.data,
      });
      return { ok: true };
    } catch (err) {
      // A network failure or a 500 with an HTML body leaves err.response or its data
      // undefined, and reading .errors straight off it threw inside the catch -- which
      // took out the whole handler, so the screen showed nothing at all.
      const errors = err?.response?.data?.errors;
      const message = errors
        ? `Error.. ${errors.codeName} ${JSON.stringify(errors.keyValue)}`
        : "Vehicle type could not be saved. Please try again.";

      dispatch({
        type: VEHICLE_TYPE_ERROR,
        payload: { msg: err?.response, status: err?.response },
      });
      return { ok: false, message };
    }
  };
